import Axios from 'axios';
const bp = '/bp';

const get_function = (url, success, params = {}, signal = null) => {
  const token = localStorage.getItem('Token');
  Axios.get(url, {
    params,
    signal,
    headers: { Authorization: `Bearer ${token}` },
  })
    .then((res) => success(res))
    .catch((error) => console.error('GET error:', error));
};

const post_function = async (url, success, data) => {
  const token = localStorage.getItem('Token');
  try {
    const response = await Axios.post(url, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    });
    success(response);
  } catch (error) {
    success(error.response || error);
  }
};

const update_function = async (url, success, data) => {
  const token = localStorage.getItem('Token');
  try {
    const response = await Axios.put(url, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    });
    success(response);
  } catch (error) {
    success(error.response || error);
  }
};

// ─── Rules CRUD ───────────────────────────────────────────────────────────────

export const get_rules_list = (success, params = {}, signal = null) =>
  get_function(`${bp}/get_rules_list`, success, params, signal);

export const create_rule = (success, data) =>
  post_function(`${bp}/create_rule`, success, data);

export const update_rule = (success, data) =>
  update_function(`${bp}/update_rule`, success, data);

// ─── Master data fetches used by rule sub-op forms ────────────────────────────

export const get_material_inventory = (success, params = {}, signal = null) =>
  get_function(`${bp}/bp_get_material_inventory`, success, params, signal);

export const get_parameters = (success, params = {}, signal = null) =>
  get_function(`${bp}/bp_get_parameters`, success, params, signal);

export const get_sensor_list = (success, params = {}, signal = null) =>
  get_function(`${bp}/get_sensor_list`, success, params, signal);

export const get_actionlist_data = (success, params = {}, signal = null) =>
  get_function(`${bp}/get_actionlist_data`, success, params, signal);

// export const get_device_details = (success, params = {}, signal = null) =>
//   get_function(`${bp}/get_device_details`, success, params, signal);

export const get_all_testing_type = (success, params = {}, signal = null) =>
  get_function(`${bp}/bp_get_all_testing_type`, success, params, signal);

export const get_departments = (success, params = {}, signal = null) =>
  get_function(`${bp}/departdata`, success, params, signal);

export const get_clearence_type = (success, params = {}, signal = null) =>
  get_function(`${bp}/get_clearence_type`, success, params, signal);

export const get_cleaning_type_for_line = (success, params = {}, signal = null) =>
  get_function(`${bp}/get_cleaning_type_for_line`, success, params, signal);

export const get_calculation_field = (success, params = {}, signal = null) =>
  get_function(`${bp}/get_calculation_field`, success, params, signal);

export const get_units = (success, params = {}, signal = null) =>
  get_function(`${bp}/bp_get_unit`, success, params, signal);

export const get_machine_types = (success, params = {}, signal = null) =>
  get_function(`${bp}/bp_machine_cat_data`, success, params, signal);

export const get_register_machine = (success, params = {}, signal = null) =>
  get_function(`${bp}/get_register_machine`, success, params, signal);

export const get_register_by_machine = (success, params = {}, signal = null) =>
  get_function(`${bp}/get_register_by_machine`, success, params, signal);
